import { render, staticRenderFns } from "./CloseMSIcon.vue?vue&type=template&id=15b7d591"
import script from "./CloseMSIcon.vue?vue&type=script&lang=js"
export * from "./CloseMSIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports